import styled from 'styled-components';

export const FeedbackContainer = styled.div`
  height: 100vh;
  display: flex;
`;
